<mat-drawer-container class="example-container" *ngIf="user !== null">
  <mat-drawer #drawer class="example-sidenav" mode="over" position="end" style="width: 280px;z-index: 9999;">
    <div class="drawer-container">
      <div class="user-card" *ngIf="!isGuestUser">

        <div class="avatar">
          <button *ngIf="!user_image || hostImageError" class="profile-image">
            {{displayName ? displayName.charAt(0).trim() : 'Hi!'}}
          </button>
          <img *ngIf="user_image  && !hostImageError" (error)="onHostImageError()" [src]="user_image" alt="User Avatar"
            class="avatar">
        </div>
        <br>
        <div class="user-info">
          <div class="name">{{ displayName ? displayName : 'User' }}</div>
          <div class="email">{{ email }}</div>
        </div>
      </div>
      <!-- <div class="user-card" *ngIf="isGuestUser">
        <div class="user-info">
          <button class="btn" type="button" (click)="login()">Login</button>
        </div>
      </div>  -->
      <nav class="menu-list">
        <a href="#" *ngIf="!isGuestUser" class="menu-item" (click)="drawer.close()" routerLink="/my-account">Profile</a>
        <!-- <a (click)="drawer.close()"
          *ngIf="user?.email == 'himanshi1488@gmail.com' || user?.email == 'raju77@gmail.com' || user?.email == 'himanshi@proximous.com'  ||  user?.email == 'sngorule05@gmail.com' ||  user?.email == 'shubhamgorule.design@gmail.com' ||  user?.email == 'rakshar95@gmail.com'"
          href="#" routerLink="/admin-menu" class="menu-item">Admin Menu</a> -->
        <a (click)="drawer.close()" *ngIf="photoWallAccess == 1 || brandingAccess || publicAccess == 1" href="#"
          routerLink="/admin-menu" class="menu-item">Admin Menu</a>
        <!-- <a (click)="drawer.close()" *ngIf="photoWallAccess == 1 || brandingAccess == 1 || publicAccess == 1" href="#"
          routerLink="/demo-event" [queryParams]="{hex: '465db503'}" class="menu-item">Demo Event</a> -->
        <!-- <a href="#" *ngIf="!isGuestUser" class="menu-item" (click)="drawer.close()" routerLink="/pricing">Pricing</a>
        <a href="#" *ngIf="!isGuestUser" class="menu-item" (click)="drawer.close()"
          routerLink="/purchase-history">Purchase History</a> -->
        <a href="#" class="menu-item" (click)="drawer.close()" routerLink="/choose-subscription">My Plan</a>
        <!-- <a href="#" class="menu-item" (click)="drawer.close()" routerLink="/choose-subscription-v2">My Plan (TEST)</a> -->
        <a href="#" class="menu-item" (click)="drawer.close()" routerLink="/how-to-videos">How-to Videos</a>
        <a href="https://picaggo.tawk.help" class="menu-item" target="_blank" (click)="drawer.close()">Help</a>
        <hr>
        <a href="#" (click)="downloadApp()" (click)="drawer.close()" class="menu-item">Picaggo App</a>
        <a href="https://picaggo.com/termsofuse.html" class="menu-item" (click)="drawer.close()" target="_blank">Terms
          of Use</a>
        <a (click)="drawer.close()" href="https://picaggo.com/EULA.html" class="menu-item">User agreement</a>
        <a (click)="drawer.close()" href="https://picaggo.com/PrivacyPolicy.html" class="menu-item">Privacy Policy</a>
        <a (click)="drawer.close()" href="#" class="menu-item" (click)="logout()">Logout</a>
      </nav>
      <a style="bottom: 0;position: fixed;font-size: 10px;
        font-style: italic;
        padding: 5px;;">App Version: {{ version }}</a>
    </div>
  </mat-drawer>


  <!-- <mat-drawer #drawer class="example-s`idenav" mode="over" position="end" style="width: 280px;z-index: 9999;">
    <mat-nav-list>
      <a mat-list-item>Hi {{ displayName ? displayName : 'User' }}, </a>
      <sub style="font-family: 'Manrope';font-size: 12px;font-style: italic; margin: 16px;">{{ email }}</sub>
      <hr>
      <a mat-list-item (click)="downloadApp()">Picaggo App </a>
      <div style="position: relative; bottom: 0; width: 100%">
        <a *ngIf="user?.email == 'himanshi1488@gmail.com' || user?.email == 'raju77@gmail.com' || user?.email == 'himanshi@proximous.com'  || user?.email == 'nishirmehta.lsu@gmail.com' ||  user?.email == 'padesara@empiricaledge.com' ||  user?.email == 'sngorule05@gmail.com' ||  user?.email == 'shubhamgorule.design@gmail.com' ||  user?.email == 'rakshar95@gmail.com' || user?.email == 'team.picaggo@gmail.com'"
          mat-list-item routerLink="/admin-menu" style="height: 45px !important;">Admin Menu</a>

        <a mat-list-item target="_blank" style="height: 45px !important;" href="https://picaggo.com/EULA.html">User
          Agreement</a>

        <a mat-list-item target="_blank" style="height: 45px !important;"
          href="https://picaggo.com/PrivacyPolicy.html">Privacy Policy</a>

        <a mat-list-item (click)="logout()" style="height: 45px !important;">Logout
        </a>

        <a style="bottom: 0;position: fixed;    font-size: 12px;
        font-style: italic;
        padding: 5px;;">App Version: {{ version }}</a>
      </div>
    </mat-nav-list>
  </mat-drawer> -->
  <header class="top-bar">
    <div class="logo" (click)="goHome()" style="cursor: pointer;">
      <!-- <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_638_6047)">
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M31.6159 12.6386C31.6159 12.0173 32.1123 11.5137 32.7246 11.5137H39.7682C40.3806 11.5137 40.8769 12.0173 40.8769 12.6386C40.8769 13.2598 40.3806 13.7635 39.7682 13.7635H32.7246C32.1123 13.7635 31.6159 13.2598 31.6159 12.6386ZM6.73841 18.067C6.73841 16.2032 8.22758 14.6923 10.0646 14.6923H37.5508C39.3878 14.6923 40.8769 16.2032 40.8769 18.067V30.5909C40.8769 32.4547 39.3878 33.9656 37.5508 33.9656H26.7534C22.6812 33.9656 19.38 30.6162 19.38 26.4846C19.38 24.4484 20.1818 22.6023 21.4825 21.2534H16.3402C15.7279 21.2534 15.2315 21.757 15.2315 22.3783V35.4515C15.2315 36.0728 15.7279 36.5764 16.3402 36.5764H49.7916C50.4039 36.5764 50.9003 37.0801 50.9003 37.7013C50.9003 38.3226 50.4039 38.8262 49.7916 38.8262H16.3402C14.5032 38.8262 13.014 37.3153 13.014 35.4515V22.3783C13.014 20.5145 14.5032 19.0036 16.3402 19.0036H26.7534C30.8257 19.0036 34.1268 22.3529 34.1268 26.4846C34.1268 28.5207 33.3251 30.3669 32.0244 31.7158H37.5508C38.1631 31.7158 38.6595 31.2121 38.6595 30.5909V18.067C38.6595 17.4457 38.1631 16.9421 37.5508 16.9421H10.0646C9.45224 16.9421 8.95585 17.4457 8.95585 18.067V28.1169C8.95585 29.9807 7.46668 31.4916 5.62969 31.4916H0.487625C-0.124704 31.4916 -0.621094 30.9879 -0.621094 30.3667C-0.621094 29.7454 -0.124704 29.2418 0.487625 29.2418H5.62969C6.24202 29.2418 6.73841 28.7381 6.73841 28.1169V18.067ZM26.7534 31.7158C29.601 31.7158 31.9094 29.3737 31.9094 26.4846C31.9094 23.5954 29.601 21.2534 26.7534 21.2534C23.9059 21.2534 21.5975 23.5954 21.5975 26.4846C21.5975 29.3737 23.9059 31.7158 26.7534 31.7158Z"
            fill="white" />
        </g>
        <defs>
          <clipPath id="clip0_638_6047">
            <rect y="0.339844" width="49.6592" height="49.6592" rx="10.3457" fill="white" />
          </clipPath>
        </defs>
      </svg> -->
      <svg width="38" height="20" viewBox="0 0 38 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd"
          d="M23.7766 0.82372C23.7766 0.368792 24.1428 0 24.5944 0H29.7894C30.2411 0 30.6072 0.368792 30.6072 0.82372C30.6072 1.27865 30.2411 1.64744 29.7894 1.64744H24.5944C24.1428 1.64744 23.7766 1.27865 23.7766 0.82372ZM5.42806 4.79877C5.42806 3.43399 6.52641 2.32761 7.88129 2.32761H28.154C29.5088 2.32761 30.6072 3.43399 30.6072 4.79877V13.9695C30.6072 15.3343 29.5088 16.4407 28.154 16.4407H20.1903C17.1868 16.4407 14.752 13.9881 14.752 10.9626C14.752 9.47165 15.3433 8.11978 16.3026 7.13202H12.5099C12.0583 7.13202 11.6922 7.50082 11.6922 7.95574V17.5288C11.6922 17.9838 12.0583 18.3526 12.5099 18.3526H37.1823C37.6339 18.3526 38 18.7213 38 19.1763C38 19.6312 37.6339 20 37.1823 20H12.5099C11.155 20 10.0567 18.8936 10.0567 17.5288V7.95574C10.0567 6.59096 11.155 5.48458 12.5099 5.48458H20.1903C23.1938 5.48458 25.6286 7.9372 25.6286 10.9626C25.6286 12.4536 25.0373 13.8055 24.0779 14.7933H28.154C28.6056 14.7933 28.9717 14.4245 28.9717 13.9695V4.79877C28.9717 4.34384 28.6056 3.97505 28.154 3.97505H7.88129C7.42966 3.97505 7.06355 4.34384 7.06355 4.79877V12.1579C7.06355 13.5227 5.9652 14.6291 4.61031 14.6291H0.817744C0.366116 14.6291 0 14.2603 0 13.8054C0 13.3504 0.366116 12.9817 0.817744 12.9817H4.61031C5.06194 12.9817 5.42806 12.6129 5.42806 12.1579V4.79877ZM20.1903 14.7933C22.2905 14.7933 23.9931 13.0782 23.9931 10.9626C23.9931 8.84705 22.2905 7.13202 20.1903 7.13202C18.09 7.13202 16.3875 8.84705 16.3875 10.9626C16.3875 13.0782 18.09 14.7933 20.1903 14.7933Z"
          fill="#EE4147" />
      </svg>

      <span class="Picaggo_title">Picaggo</span>
    </div>
    <nav class="top-nav-menu" *ngIf="showTopNavMenu">
      <a routerLink="/home" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" class="nav-item">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round">
          <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
          <line x1="16" y1="2" x2="16" y2="6"></line>
          <line x1="8" y1="2" x2="8" y2="6"></line>
          <line x1="3" y1="10" x2="21" y2="10"></line>
        </svg>
        <span>My Events</span>
      </a>
      <a routerLink="/autopilot" routerLinkActive="active" class="nav-item">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round">
          <path d="M12 3l1.9 4.6L18.5 9.5l-4.6 1.9L12 16l-1.9-4.6L5.5 9.5l4.6-1.9L12 3z"></path>
          <path d="M19 14v4"></path>
          <path d="M17 16h4"></path>
          <path d="M5 4v3"></path>
          <path d="M3.5 5.5h3"></path>
        </svg>
        <span>Autopilot</span>
      </a>
      <a routerLink="/reels" routerLinkActive="active" class="nav-item" (click)="onReelsNavClick()">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round">
          <rect x="2" y="2" width="20" height="20" rx="2.18" ry="2.18"></rect>
          <line x1="7" y1="2" x2="7" y2="22"></line>
          <line x1="17" y1="2" x2="17" y2="22"></line>
          <line x1="2" y1="12" x2="22" y2="12"></line>
          <line x1="2" y1="7" x2="7" y2="7"></line>
          <line x1="2" y1="17" x2="7" y2="17"></line>
          <line x1="17" y1="17" x2="22" y2="17"></line>
          <line x1="17" y1="7" x2="22" y2="7"></line>
        </svg>
        <span>Reels</span>
      </a>
      <a routerLink="/invitation" routerLinkActive="active" class="nav-item">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round">
          <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
          <polyline points="22,6 12,13 2,6"></polyline>
        </svg>
        <span>Templates</span>
      </a>
      <!--
      <div class="nav-item">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M9 18h6"></path>
          <path d="M10 22h4"></path>
          <path d="M12 2a7 7 0 0 0-4 12.7c.6.5 1 .9 1 2.3h6c0-1.4.4-1.8 1-2.3A7 7 0 0 0 12 2z"></path>
        </svg>
        <span>Pro-tip</span>
      </div>
      <div class="nav-item">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect>
          <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>
        </svg>
        <span>Free Tools</span>
      </div>
      -->
    </nav>
    <div class="top-bar-actions">
      <button class="action-btn" *ngIf="showThemeSwitch" (click)="themeService.toggle()" [matTooltip]="themeService.isDark ? 'Switch to light mode' : 'Switch to dark mode'">
        <svg *ngIf="!themeService.isDark" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path>
        </svg>
        <svg *ngIf="themeService.isDark" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="5"></circle>
          <line x1="12" y1="1" x2="12" y2="3"></line><line x1="12" y1="21" x2="12" y2="23"></line>
          <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line>
          <line x1="1" y1="12" x2="3" y2="12"></line><line x1="21" y1="12" x2="23" y2="12"></line>
          <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line>
        </svg>
      </button>
      <button class="action-btn" (click)="refreshPage()" matTooltip="Refresh">
        <mat-icon class="refresh-icon">refresh</mat-icon>
      </button>
      <button class="action-btn" (click)="toggleNotifications()" matTooltip="Notifications">
        <svg width="15pt" height="15pt" version="1.1" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" fill="currentColor">
        <path
          d="m12.75 81.43c5.8281 0.53125 12.141 0.92187 18.691 1.1719 0.46875 0.019532 0.87891 0.33984 1.0195 0.76953 2.3516 7.3086 9.5508 11.641 17.551 11.602 8 0.039063 15.191-4.2891 17.551-11.602 0.14062-0.42969 0.55078-0.75 1.0195-0.76953 6.5508-0.25 12.859-0.64062 18.691-1.1719 1.75-0.14844 3.1094-1.8516 3.1016-3.7617v-7.6914c-0.03125-5.6992-1.4414-11.18-4.3516-15.801-2.1602-3.4102-3.4609-7.8203-3.5-12.211-0.019532-1.9102-0.050782-3.8086-0.078126-5.6992 0.070313-18.012-14.609-31.57-31.48-31.238-17.43-1.1211-33.41 11.898-33.359 30.551-0.039063 2.1211-0.070313 4.25-0.089844 6.3789-0.039063 4.3906-1.3398 8.8086-3.5 12.211-2.8984 4.6211-4.3203 10.102-4.3516 15.801v7.6914c0 1.9102 1.3516 3.6016 3.1016 3.7617zm37.25 7.8398c-4.0703 0-7.6406-1.9609-9.5703-5.0586-0.37891-0.60938 0.12109-1.3398 0.89062-1.3281 5.7617 0.10156 11.609 0.10156 17.371 0 0.76953-0.011718 1.2695 0.71875 0.89062 1.3281-1.9414 3.1016-5.5117 5.0586-9.5703 5.0586zm-34.391-18.719c-0.089844-4.2695 1.0586-8.4609 3.3711-11.898 3.1719-4.6914 5.0391-10.75 5.1094-16.871 0.019531-1.9883 0.058594-3.9688 0.10156-5.9414 0.23047-14.488 12.352-25.559 26.23-25.109 13.512-0.03125 25.129 10.441 25.371 24.531 0.050781 2.1602 0.089843 4.3281 0.10938 6.5195 0.070312 6.1289 1.9414 12.18 5.1094 16.871 2.3086 3.4414 3.4609 7.6289 3.3711 11.898-0.03125 1.1016-0.050781 2.1914-0.078124 3.2812-0.011719 0.55078-0.42969 1.0312-0.92969 1.0703-20.012 1.6719-46.73 1.6719-66.738 0-0.5-0.039063-0.92188-0.51953-0.92969-1.0703-0.03125-1.0898-0.058593-2.1797-0.078125-3.2812z" />
      </svg>

        <span class="bell-badge" *ngIf="unreadCount > 0">{{ unreadCount > 9 ? '9+' : unreadCount }}</span>
      </button>
      <button class="action-btn" (click)="showNotifications = false; drawer.toggle()" matTooltip="Menu">
        <!-- <app-icon style="    margin-top: 6px;" name="sidebar" width="20" height="20" fill="currentColor"></app-icon> -->
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
          <path d="M26.666 9.33301L5.33268 9.33301" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
          <path d="M26.666 16L5.33268 16" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
          <path d="M26.666 22.667L5.33268 22.667" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
        </svg>
      </button>
    </div>
  </header>
</mat-drawer-container>

<!-- Notification Sidebar -->
<div class="notif-overlay" *ngIf="showNotifications" (click)="toggleNotifications()"></div>
<div class="notif-sidebar" [class.open]="showNotifications">
  <div class="notif-header">
    <span class="notif-title">Notifications</span>
    <button class="notif-close-btn" (click)="toggleNotifications()">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
        <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
      </svg>
    </button>
  </div>
  <div class="notif-body">
    <div *ngIf="notifications.length === 0" class="notif-empty">
      <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12 22C13.1 22 14 21.1 14 20H10C10 21.1 10.9 22 12 22ZM18 16V11C18 7.93 16.36 5.36 13.5 4.68V4C13.5 3.17 12.83 2.5 12 2.5C11.17 2.5 10.5 3.17 10.5 4V4.68C7.63 5.36 6 7.92 6 11V16L4 18V19H20V18L18 16Z"
          fill="#ccc" />
      </svg>
      <p>No notifications yet</p>
    </div>

    <!-- Event Transfer group -->
    <ng-container *ngIf="hostTransferNotifications.length > 0">
      <div class="notif-section-label">Event Transfer</div>
      <div class="notif-group-card">
        <div class="notif-item" *ngFor="let n of hostTransferNotifications" [class.unread]="!n.read"
          (click)="openReview(n)">
          <div class="notif-icon-wrap">
            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="40" height="40" rx="20" fill="#F0F0F0" />
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M30 20C30 25.5228 25.5228 30 20 30C14.4772 30 10 25.5228 10 20C10 14.4772 14.4772 10 20 10C25.5228 10 30 14.4772 30 20ZM15 22.75L23 22.75L21.0693 24.4349C20.7573 24.7073 20.7251 25.1811 20.9974 25.4931C21.2698 25.8052 21.7436 25.8374 22.0557 25.5651L25.4932 22.5651C25.7287 22.3595 25.812 22.0294 25.7022 21.7367C25.5925 21.4439 25.3126 21.25 25 21.25L15 21.25C14.5858 21.25 14.25 21.5858 14.25 22C14.25 22.4142 14.5858 22.75 15 22.75ZM19.0026 14.5068C19.2749 14.8189 19.2427 15.2927 18.9307 15.5651L17 17.25H25C25.4142 17.25 25.75 17.5858 25.75 18C25.75 18.4142 25.4142 18.75 25 18.75H15C14.6874 18.75 14.4075 18.5561 14.2978 18.2633C14.188 17.9706 14.2713 17.6405 14.5068 17.4349L17.9443 14.4349C18.2564 14.1626 18.7302 14.1948 19.0026 14.5068Z"
                fill="#131A26" />
            </svg>


          </div>
          <div class="notif-content">
            <div class="notif-item-msg">{{ n.message }}</div>
            <div class="notif-item-time">{{ formatNotifTime(n.created_at) }}</div>
          </div>
          <!-- <svg class="notif-chevron" width="18" height="18" viewBox="0 0 24 24" fill="none">
            <path d="M9 5L15 12L9 19" stroke="#bbb" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg> -->
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M9 5L15 12L9 19" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
        </div>
      </div>
    </ng-container>

    <!-- Others group -->
    <ng-container *ngIf="otherNotifications.length > 0">
      <div class="notif-section-label">Others</div>
      <div class="notif-group-card">
        <div class="notif-item" *ngFor="let n of otherNotifications" [class.unread]="!n.read">
          <div class="notif-icon-wrap">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <path d="M7 16L3 12M3 12L7 8M3 12H21M17 8L21 12M21 12L17 16" stroke="#fff" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </div>
          <div class="notif-content">
            <div class="notif-item-msg">{{ n.message }}</div>
            <div class="notif-item-time">{{ formatNotifTime(n.created_at) }}</div>
          </div>
          <svg class="notif-chevron" width="18" height="18" viewBox="0 0 24 24" fill="none">
            <path d="M9 5L15 12L9 19" stroke="#bbb" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </div>
      </div>
    </ng-container>
  </div>
</div>

<!-- Host Transfer Review Modal (moved to /host-transfer page) -->
<!-- <div class="review-overlay" *ngIf="showReviewModal" (click)="closeReviewModal()"></div>
<div class="review-modal" *ngIf="showReviewModal && selectedNotification">
  <div class="review-modal-header">
    <div class="review-avatar">{{ selectedNotification.from_user_name?.charAt(0)?.toUpperCase() || '?' }}</div>
    <div class="review-header-info">
      <div class="review-sender">{{ selectedNotification.from_user_name || 'Someone' }}</div>
      <div class="review-subtitle">requested you to become host</div>
    </div>
  </div>

  <div class="review-event-pill">
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none"><path d="M8 7V3M16 7V3M7 11H17M5 21H19C20.1 21 21 20.1 21 19V7C21 5.9 20.1 5 19 5H5C3.9 5 3 5.9 3 7V19C3 20.1 3.9 21 5 21Z" stroke="#7c3aed" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
    <span>{{ selectedNotification.event_name }}</span>
  </div>

  <div class="review-info-box" *ngIf="!isStorageFull">
    <div class="review-info-row">
      <span class="review-info-icon review-icon-green">✓</span>
      <span>You will become the new host of this event</span>
    </div>
    <div class="review-info-row">
      <span class="review-info-icon review-icon-gray">⇄</span>
      <span>Current host will become a collaborator</span>
    </div>
    <div class="review-info-row">
      <span class="review-info-icon review-icon-yellow">!</span>
      <span>This action cannot be undone once accepted</span>
    </div>
  </div>

  <div class="review-storage-box" *ngIf="isStorageFull">
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M12 9V13M12 17H12.01M10.29 3.86L1.82 18C1.64 18.32 1.55 18.68 1.55 19.05C1.55 20.12 2.42 21 3.5 21H20.5C21.58 21 22.45 20.12 22.45 19.05C22.45 18.68 22.36 18.32 22.18 18L13.71 3.86C13.32 3.33 12.69 3 12 3C11.31 3 10.68 3.33 10.29 3.86Z" stroke="#d97706" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
    <div class="review-storage-text">
      <strong>Storage limit reached</strong>
      <p>You need more storage to become the host of this event. Upgrade your plan to continue.</p>
    </div>
  </div>

  <div class="review-actions" *ngIf="!isStorageFull">
    <button class="review-reject-btn" (click)="rejectHostTransfer()" [disabled]="isReviewLoading">Reject</button>
    <button class="review-accept-btn" (click)="acceptHostTransfer()" [disabled]="isReviewLoading">
      <span *ngIf="!isReviewLoading">Accept</span>
      <span *ngIf="isReviewLoading" class="loader-small"></span>
    </button>
  </div>
  <div class="review-actions" *ngIf="isStorageFull">
    <button class="review-cancel-text-btn" (click)="closeReviewModal()">Cancel</button>
    <button class="review-upgrade-btn" (click)="router.navigate(['/choose-subscription']); closeReviewModal()">Upgrade Storage</button>
  </div>
</div> -->

<!-- Login Popup for Guest Users -->
<app-login-popup *ngIf="showLoginPopup" (closePopup)="closeLoginPopup()"></app-login-popup>